
// // development
// const host = "http://localhost:9020";
// const host = "http://localhost:9018";

// const host = "Complete Your Booking";

// // production
// const host = "http://31.97.206.32:9018";

// // shreeshtech demo
// const host = "http://31.97.206.32:9020";

// const host = "http://72.61.227.122:9018";

// // after ssl and domain implemetation on host
const host = 'https://api.hotelkadamba.com';

// const host = 'https://api.srichakraresidency.com';


const BASE_URL = `${host}/api/v1`;
const BASE = `${host}`;
const BASE1 = `${host}/`;
const image_path = `${host}/uploads/`;
const image_path_1 = `${host}/uploads`;
const image_header = `${host}/header/`;

const PRODUCT = "product";

// const BASE_URL = "http://31.97.206.32:9001/api/v1/";
// const BASE = "http://31.97.206.32:9001";

export const ENDPOINTS = {
  BASE: BASE_URL,
  cleanBase: BASE,
  cleanBase1: BASE1,
  IMG_PATH: image_path,
  IMG_PATH_1: image_path_1,
  IMG_HEADER: image_header,
  ROOM_DETAILS: `${BASE_URL}/products`,
  CHECKOUT_ROOM: `${BASE_URL}/products/checkout`,
  GET_ALL_TABLE: `${BASE_URL}/get-table`,
  ROOM_BY_DATE: `${BASE_URL}/rooms-by-date`,
  MEDIA_UPLOAD: `${BASE_URL}/upload/image`,

  HEADER_UPLOAD: `${BASE_URL}/upload/upload-header`,
  FOOTER_UPLOAD: `${BASE_URL}/upload/upload-footer`,
  A4_PDF_HEADER_UPLOAD: `${BASE_URL}/upload/upload-a4-pdf-header`,

  AMENITIES: `${BASE_URL}/amenities`,
  ROOMBYTYPE: `${BASE_URL}/products/by-type`,
  SEASONAL_PRICE: `${BASE_URL}/products/seasonal-price`,
  PRICE_UPDATE: `${BASE_URL}/products/update-room-rate`,
  UPLOADED_IMAGES: `${BASE_URL}/products/images/all`,
  REINDEX: `${BASE_URL}/auth/re-index`,
  LOYALTY_OFFER: `${BASE_URL}/get-loyality-offer`,

  // one for all
  CREATE: `${BASE_URL}/create`,
  GET: `${BASE_URL}/get`,
  GET_BY_ID: `${BASE_URL}/get-byid`,
  UPDATE: `${BASE_URL}/edit`,
  DELETE: `${BASE_URL}/delete`,
  BOOK_LOG: `${BASE_URL}/book_log`,

  CANCEL_RESER :`${BASE_URL}/cancle-reservation`,

  // bookings
  BOOKROOM: `${BASE_URL}/products/book-room`,
  BULK_BOOKROOM: `${BASE_URL}/products/bulk-book-room`,
  DOC_DELETE: `${BASE_URL}/products/documents`,

  //checkout
  CHECKOUT: `${BASE_URL}/products/checkout-room`,
  ROOM_LOG: `${BASE_URL}/products/room-history`,

  SERVICE_REQUESTS: `${BASE_URL}/products/room-services`,
  EXPENSE: `${BASE_URL}/expense/create`,
  EDIT_EXPENSE: `${BASE_URL}/expense/edit`,
  GET_EXPENSE: `${BASE_URL}/expense`,
  
  DELETE_EXPENSE: `${BASE_URL}/expense/expense`,
  DELETE_EXPENSE_ITEM: `${BASE_URL}/expense/expense-item`,

  SER_REQ: `${BASE_URL}/expense/service-requests`,
  UPCOMING_RESERVATIONS: `${BASE_URL}/products/upcoming-reservations`,
  GET_ONLINE_ORDER: `${BASE_URL}/products/online-order`,

 USER_PERMISSIONS: `${BASE_URL}/users`,

  
};
